import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ROUTES } from "utils/constants";
import { projectList } from "slices/project";
import { getUserInvitations } from "slices/user";
import ProjectHeader from "../project-header/ProjectHeader";
import { logout } from "slices/user";
import { AppLayout } from "../app-layout";

const ProjectDashboard = ({ props }) => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const { data } = useSelector((state) => state.projects);
    const { userInvitations } = useSelector((state) => state.user);
    const [projects, setProjects] = useState([]);
    const [selectedproject, setSelectedproject] = useState(null);
    const [invitedData, setInvitedData] = useState(false);
    const [userLinks, setUserLinks] = useState([]);

    const { firstName, lastName, baseCurrency } = useSelector(
        (state) => state.user
    );
    const { currentBalance } = useSelector((state) => state.payment);

    const userLogout = () => {
        dispatch(logout({ mode: "manual" }));
    };

    useEffect(() => {
        document.body.classList.add("loaded");
        document.body.classList.remove("dashboard-container");


        return () => {
            document.body.classList.add("dashboard-container");
            document.body.classList.remove("loaded");
        };
    }, []);

    useEffect(() => {
        setSelectedproject(null);
        dispatch(projectList());
        dispatch(getUserInvitations());
    }, [id]);

    useEffect(() => {
        if (data.length > 0) {
            setSelectedproject(data.filter((item) => item.id == id)[0]);
            setProjects(data.filter((item) => item.id != id));
        }
    }, [data]);

    useEffect(() => {
        setInvitedData([]);
        if (userInvitations.length > 0) {
            const updatedList = userInvitations.map((item) => {
                return { ...item, isLoading: false };
            });
            setInvitedData(updatedList);
        }
    }, [userInvitations]);

    const userLinkList = [
        {
            to: ROUTES.SERVERS,
            label: "INSTANCES",
            image1: "/assets/images/icons/servers-1.svg",
            image2: "/assets/images/icons/servers-2.svg",
        },
        {
            to: ROUTES.VOLUMES,
            label: "VOLUMES",
            image1: "/assets/images/icons/volumes-1.svg",
            image2: "/assets/images/icons/volumes-2.svg",
        },
        {
            to: ROUTES.IMAGES,
            label: "IMAGES",
            image1: "/assets/images/icons/images-1.svg",
            image2: "/assets/images/icons/images-2.svg",
        },
        {
            to: ROUTES.FLOATING_IP,
            label: "FLOATING IP",
            image1: "/assets/images/icons/floating-1.svg",
            image2: "/assets/images/icons/floating-2.svg",
        },
        {
            to: ROUTES.NETWORKS,
            label: "NETWORKS",
            image1: "/assets/images/icons/network-icon-1.svg",
            image2: "/assets/images/icons/network-icon-2.svg",
        },
        {
            to: ROUTES.USERS,
            label: "USERS",
            image1: "/assets/images/icons/users-1.svg",
            image2: "/assets/images/icons/users-2.svg",
        },
        {
            to: ROUTES.EVENTS,
            label: "EVENTS",
            image1: "/assets/images/icons/events-1.svg",
            image2: "/assets/images/icons/events-2.svg",
        },
        // {
        //     to: ROUTES.DELETE,
        //     label: "DELETE",
        //     image1: "/assets/images/icons/Delete.svg",
        //     image2: "/assets/images/icons/Delete-2.svg",
        // },
    ];

    const uniqueById = (items) => {
        const set = new Set();
        return items.filter((item) => {
            const isDuplicate = set.has(item.label);
            set.add(item.label);
            return !isDuplicate;
        });
    };

    useEffect(() => {
        for (let i = 0; i < userLinkList.length; i++) {
            setUserLinks((userLinksLi) => {
                return uniqueById([...userLinksLi, userLinkList[i]]);
            });
        }
    }, []);

    useEffect(() => {
        if (selectedproject && selectedproject.owner) {
            setUserLinks((userLinksLi) => {
                return uniqueById([
                    ...userLinksLi,
                    {
                        to: ROUTES.DELETE,
                        label: "DELETE",
                        image1: "/assets/images/icons/Delete.svg",
                        image2: "/assets/images/icons/Delete-2.svg",
                    },
                ]);
            });
        } else {
            if (userLinks.length > 0) {
                const filteredList = userLinks.filter(
                    (item) => item.label !== "DELETE"
                );
                setUserLinks(filteredList);
            }
        }
    }, [selectedproject]);


    return (
        <AppLayout>
            <div className="content outer-div">
                <div className="row mx-0">
                    <div className="col-auto px-0">
                        <aside>
                            <Link to={"/"+ROUTES.PROJECT}>
                                <img src="/assets/images/cloud-logo-white.svg" alt=""
                                    className="img-fluid d-block mb-5 mx-auto aside-logo" />
                            </Link>
                            <div className="aside-nav  aside-nav-inline">
                                {userLinks.map(({ to, label, image1, image2 }) => (
                                    <NavLink
                                        key={to}
                                        to={to}
                                        className={({ isActive }) =>
                                            isActive ? "aside-nav-link active" : "aside-nav-link"
                                        }
                                    >
                                        <span className="nav-icon">
                                            <img src={image1} alt="" className="img-fluid me-2" />
                                            <img src={image2} alt="" className="img-fluid me-2" />
                                        </span>
                                        <span className="link-text ">{label}</span>
                                    </NavLink>
                                ))}
                            </div>
                        </aside>
                    </div>
                    <div className="col">
                        <div className="content-block">
                            <ProjectHeader
                                userName={firstName + " " + lastName}
                                baseCurrency={baseCurrency}
                                currentBalance={currentBalance}
                                userLogout={userLogout} />

                        </div>
                    </div>
                </div>
            </div >
        </AppLayout>
    )
}

export default ProjectDashboard;